import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, EventEmitter, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i2$2 from '@rogers/cdk/button';
import { ButtonComponent } from '@rogers/cdk/button';
import * as i2$1 from '@rogers/cdk/modal';
import { ModalModule } from '@rogers/cdk/modal';
import * as i2 from '@rogers/cdk/price';
import { PriceComponent } from '@rogers/cdk/price';
import { TileComponent } from '@rogers/cdk/tile';
import * as i7 from '@rogers/self-serve-utils/custom-date';
import { CustomDateModule } from '@rogers/self-serve-utils/custom-date';
import * as i4 from '@rogers/self-serve-analytics';
import { AnalyticsModule } from '@rogers/self-serve-analytics';
import * as i3 from '@rogers/self-serve-utils/tile-with-header';
import { TileWithHeaderModule } from '@rogers/self-serve-utils/tile-with-header';
import * as i1$2 from '@rogers/cdk/common/classes';
import { ModalInjectableData } from '@rogers/cdk/common/classes';
import * as i3$1 from '@rogers/self-serve-utils/quick-links';
import { QuickLinkService, QuickLinksModule } from '@rogers/self-serve-utils/quick-links';
import * as i1$3 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, StoreModule } from '@ngrx/store';
import { of } from 'rxjs';
import { filter, withLatestFrom, tap, switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { createEntityAdapter } from '@ngrx/entity';
import * as i1$4 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import * as i3$2 from '@angular/common/http';
import { parseISOString } from '@rogers/self-serve-utils';
const _c0 = (a0, a1) => ({
  description: "total-monthly-financing-payment",
  frequency: a0,
  price: a1
});
const _c1 = (a0, a1) => ({
  class: "mb-8",
  description: "monthly-financing-payment",
  frequency: a0,
  price: a1
});
const _c2 = (a0, a1) => ({
  class: "",
  description: "monthly-financed-taxes",
  frequency: a0,
  price: a1
});
const _c3 = a0 => ({
  description: "total-remaining-financing-balance",
  frequency: "",
  price: a0
});
const _c4 = a0 => ({
  class: "mb-8",
  description: "remaining-financing-balance",
  frequency: "",
  price: a0
});
const _c5 = a0 => ({
  class: "",
  description: "remaining-financed-taxes",
  frequency: "",
  price: a0
});
function AccessoriesBalanceComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "ds-price", 10);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const description_r1 = ctx.description;
    const price_r2 = ctx.price;
    const frequency_r3 = ctx.frequency;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, "financed-accessories." + description_r1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ariaLiveDesc", i0.ɵɵpipeBind1(5, 7, "financed-accessories." + description_r1))("language", ctx_r3.language)("price", price_r2)("frequency", frequency_r3);
  }
}
function AccessoriesBalanceComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "ds-price", 12);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const class_r5 = ctx.class;
    const description_r6 = ctx.description;
    const frequency_r7 = ctx.frequency;
    const price_r8 = ctx.price;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("d-flex flex-column flex-sm-row justify-content-between ", class_r5, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 9, "financed-accessories." + description_r6), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ariaLiveDesc", i0.ɵɵpipeBind1(5, 11, "financed-accessories." + description_r6))("language", ctx_r3.language)("price", price_r8)("frequency", frequency_r7)("variant", "inline");
  }
}
const _c6 = (a0, a1) => [a0, "CAD", "symbol-narrow", "1.2-2", a1];
const _c7 = (a0, a1) => ({
  totalRemainingBalance: a0,
  contractEnd: a1
});
const _c8 = () => ({
  mappingKey: "open-accessories-details-modal"
});
const _c9 = a0 => ({
  contractEnd: a0
});
const _c10 = a0 => ({
  contractStart: a0
});
const _c11 = a0 => ({
  agreementNumber: a0
});
const _c12 = a0 => ({
  agreementTerm: a0
});
const _c13 = a0 => ({
  quantity: a0
});
function AccessoriesDetailsComponent_For_47_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "img", 18);
    i0.ɵɵelementStart(2, "div", 19)(3, "span", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 22);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 5);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "currency");
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span", 23);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const accessory_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("alt", accessory_r1.name);
    i0.ɵɵpropertyInterpolate("src", accessory_r1.iconUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(accessory_r1.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(accessory_r1.description);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(9, 8, "financed-accessories.items", i0.ɵɵpureFunction1(21, _c13, accessory_r1.quantity)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBindV(12, 11, i0.ɵɵpureFunction2(23, _c6, accessory_r1.price, ctx_r1.language)), " ", i0.ɵɵpipeBind1(13, 17, "financed-accessories.each"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 19, "financed-accessories.retail-price"));
  }
}
const _forTrack0 = ($index, $item) => $item.agreementNumber;
const _c14 = a0 => ({
  account: a0
});
function AccessoriesComponent_For_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "ss-accessories-details", 10);
    i0.ɵɵlistener("modalAgreementDetails", function AccessoriesComponent_For_11_Template_ss_accessories_details_modalAgreementDetails_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openAgreementDetailsModal($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const agreementDetail_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("agreementDetail", agreementDetail_r3)("language", ctx_r1.accessoriesDetail.language);
  }
}
let AccessoriesConfigService = /*#__PURE__*/(() => {
  class AccessoriesConfigService {
    /** @nocollapse */static {
      this.ɵfac = function AccessoriesConfigService_Factory(t) {
        return new (t || AccessoriesConfigService)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccessoriesConfigService,
        factory: AccessoriesConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessoriesConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesBalanceComponent = /*#__PURE__*/(() => {
  class AccessoriesBalanceComponent {
    constructor() {
      this.headerClass = 'p-24 p-sm-32';
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesBalanceComponent_Factory(t) {
        return new (t || AccessoriesBalanceComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AccessoriesBalanceComponent,
        selectors: [["ss-accessories-balance"]],
        inputs: {
          accessoriesDetail: "accessoriesDetail",
          headerClass: "headerClass",
          language: "language"
        },
        decls: 18,
        vars: 34,
        consts: [["totalMonthlyOrRemainingSection", ""], ["monthlyOrRemainingSection", ""], [3, "headerClass"], ["header", ""], [1, "d-flex", "flex-column", "flex-lg-row"], [1, "d-flex", "flex-column", "col-lg-6", "mb-32", "mb-lg-0", "pl-0", "pr-0", "pr-lg-48"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "d-flex", "flex-column", "col-lg-6", "pl-0", "pl-lg-48", "pr-0"], [1, "d-flex", "flex-column", "flex-sm-row", "justify-content-between", "mb-16"], [1, "text-title-4"], [1, "balance-value", "text-left", "text-sm-right", 3, "ariaLiveDesc", "language", "price", "frequency"], [1, "text-body", "mb-0"], [1, "balance-value", "text-body", "text-left", "text-sm-right", "mb-0", 3, "ariaLiveDesc", "language", "price", "frequency", "variant"]],
        template: function AccessoriesBalanceComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ss-tile-with-header", 2);
            i0.ɵɵelementContainerStart(1, 3);
            i0.ɵɵelementStart(2, "div", 4)(3, "div", 5);
            i0.ɵɵelementContainer(4, 6);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementContainer(6, 6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementContainer(8, 6);
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵelementContainer(11, 6)(12, 6)(13, 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(14, AccessoriesBalanceComponent_ng_template_14_Template, 6, 9, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(16, AccessoriesBalanceComponent_ng_template_16_Template, 6, 13, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const totalMonthlyOrRemainingSection_r9 = i0.ɵɵreference(15);
            const monthlyOrRemainingSection_r10 = i0.ɵɵreference(17);
            i0.ɵɵproperty("headerClass", ctx.headerClass);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngTemplateOutlet", totalMonthlyOrRemainingSection_r9)("ngTemplateOutletContext", i0.ɵɵpureFunction2(19, _c0, i0.ɵɵpipeBind1(5, 13, "financed-accessories.mo"), ctx.accessoriesDetail.totalMonthlyAmount));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", monthlyOrRemainingSection_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction2(22, _c1, i0.ɵɵpipeBind1(7, 15, "financed-accessories.mo"), ctx.accessoriesDetail.preTaxMonthlyInstallment));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", monthlyOrRemainingSection_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction2(25, _c2, i0.ɵɵpipeBind1(9, 17, "financed-accessories.mo"), ctx.accessoriesDetail.taxOnMonthlyInstallment));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", totalMonthlyOrRemainingSection_r9)("ngTemplateOutletContext", i0.ɵɵpureFunction1(28, _c3, ctx.accessoriesDetail.totalRemainingBalance));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", monthlyOrRemainingSection_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(30, _c4, ctx.accessoriesDetail.preTaxRemainingBalance));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", monthlyOrRemainingSection_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction1(32, _c5, ctx.accessoriesDetail.taxOnRemainingBalance));
          }
        },
        dependencies: [i1.NgTemplateOutlet, i2.PriceComponent, i3.TileWithHeaderComponent, i1$1.TranslatePipe],
        styles: ["@-ms-viewport{width:device-width}.balance-value{width:30%;padding-left:16px}@media (max-width: 599.98px){.balance-value{width:100%;padding:0}}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return AccessoriesBalanceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesDetailsModalComponent = /*#__PURE__*/(() => {
  class AccessoriesDetailsModalComponent {
    constructor(modalData) {
      this.accessoriesModalData = modalData.source;
      this.language = modalData.source.language;
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesDetailsModalComponent_Factory(t) {
        return new (t || AccessoriesDetailsModalComponent)(i0.ɵɵdirectiveInject(i1$2.ModalInjectableData));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AccessoriesDetailsModalComponent,
        selectors: [["ss-accessories-details-modal"]],
        decls: 60,
        vars: 81,
        consts: [[3, "heading", "closeCaption"], ["body", "", "ssTrackEvent", "", 3, "event"], [1, "d-flex", "flex-column"], [1, "d-flex", "flex-column", "flex-sm-row", "justify-content-between", "text-body-lg", "mb-8"], [1, "d-flex", "flex-column", "flex-sm-row", "justify-content-between", "text-body-lg", "mb-24"], [1, "d-flex", "flex-column", "flex-sm-row", "justify-content-between", "text-title-4", "mb-8"], ["variant", "inline", 3, "price", "frequency", "language"], ["variant", "inline", 3, "price", "language"], [1, "d-flex", "flex-column", "flex-sm-row", "justify-content-between", "text-body-lg", "mb-0"]],
        template: function AccessoriesDetailsModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ds-modal", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵpipe(2, "currency");
            i0.ɵɵpipe(3, "customDate");
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementStart(5, "div", 1)(6, "div", 2)(7, "div", 3)(8, "span");
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "span");
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "customDate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 3)(15, "span");
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(18, "span");
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 4)(21, "span");
            i0.ɵɵtext(22);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "span");
            i0.ɵɵtext(25);
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(27, "div", 5)(28, "span");
            i0.ɵɵtext(29);
            i0.ɵɵpipe(30, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(31, "ds-price", 6);
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(33, "div", 3)(34, "span");
            i0.ɵɵtext(35);
            i0.ɵɵpipe(36, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(37, "ds-price", 6);
            i0.ɵɵpipe(38, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "div", 4)(40, "span");
            i0.ɵɵtext(41);
            i0.ɵɵpipe(42, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(43, "ds-price", 6);
            i0.ɵɵpipe(44, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "div", 5)(46, "span");
            i0.ɵɵtext(47);
            i0.ɵɵpipe(48, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(49, "ds-price", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(50, "div", 3)(51, "span");
            i0.ɵɵtext(52);
            i0.ɵɵpipe(53, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(54, "ds-price", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(55, "div", 8)(56, "span");
            i0.ɵɵtext(57);
            i0.ɵɵpipe(58, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(59, "ds-price", 7);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("closeCaption", i0.ɵɵpipeBind1(1, 31, "financed-accessories.modal.close"));
            i0.ɵɵproperty("heading", i0.ɵɵpipeBind2(4, 42, "financed-accessories.modal.header", i0.ɵɵpureFunction2(77, _c7, i0.ɵɵpipeBindV(2, 33, i0.ɵɵpureFunction2(74, _c6, ctx.accessoriesModalData.remainingBalance, ctx.language)), i0.ɵɵpipeBind2(3, 39, ctx.accessoriesModalData.contractEnd, ctx.language))));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("event", i0.ɵɵpureFunction0(80, _c8));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 45, "financed-accessories.modal.start-date"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(13, 47, ctx.accessoriesModalData.contractStart, ctx.language));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 50, "financed-accessories.modal.agreement-id"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.accessoriesModalData.agreementNumber);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 52, "financed-accessories.modal.financing-term"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2("", ctx.accessoriesModalData.agreementTerm, " ", i0.ɵɵpipeBind1(26, 54, "financed-accessories.months"), "");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 56, "financed-accessories.total-monthly-financing-payment"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("price", ctx.accessoriesModalData.monthlyAmount)("frequency", i0.ɵɵpipeBind1(32, 58, "financed-accessories.mo"))("language", ctx.language);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(36, 60, "financed-accessories.monthly-financing-payment"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("price", ctx.accessoriesModalData.preTaxMonthlyInstallment)("frequency", i0.ɵɵpipeBind1(38, 62, "financed-accessories.mo"))("language", ctx.language);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(42, 64, "financed-accessories.monthly-financed-taxes"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("price", ctx.accessoriesModalData.taxOnMonthlyInstallment)("frequency", i0.ɵɵpipeBind1(44, 66, "financed-accessories.mo"))("language", ctx.language);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(48, 68, "financed-accessories.total-remaining-financing-balance"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("price", ctx.accessoriesModalData.remainingBalance)("language", ctx.language);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(53, 70, "financed-accessories.remaining-financing-balance"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("price", ctx.accessoriesModalData.preTaxRemainingBalance)("language", ctx.language);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(58, 72, "financed-accessories.remaining-financed-taxes"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("price", ctx.accessoriesModalData.taxOnRemainingBalance)("language", ctx.language);
          }
        },
        dependencies: [i2.PriceComponent, i2$1.ModalComponent, i4.TrackEventDirective, i1.CurrencyPipe, i1$1.TranslatePipe, i7.CustomDatePipe],
        encapsulation: 2
      });
    }
  }
  return AccessoriesDetailsModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesDetailsComponent = /*#__PURE__*/(() => {
  class AccessoriesDetailsComponent {
    constructor() {
      this.modalAgreementDetails = new EventEmitter();
    }
    emitAgreementDetails() {
      const {
        preTaxRemainingBalance,
        taxOnRemainingBalance,
        preTaxMonthlyInstallment,
        taxOnMonthlyInstallment,
        agreementNumber,
        agreementTerm,
        contractStart,
        contractEnd,
        remainingBalance,
        monthlyAmount
      } = this.agreementDetail;
      const modalAgreementDetails = {
        preTaxRemainingBalance,
        taxOnRemainingBalance,
        preTaxMonthlyInstallment,
        taxOnMonthlyInstallment,
        agreementNumber,
        agreementTerm,
        contractStart,
        contractEnd,
        remainingBalance,
        monthlyAmount,
        language: this.language
      };
      this.modalAgreementDetails.emit(modalAgreementDetails);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesDetailsComponent_Factory(t) {
        return new (t || AccessoriesDetailsComponent)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AccessoriesDetailsComponent,
        selectors: [["ss-accessories-details"]],
        inputs: {
          agreementDetail: "agreementDetail",
          language: "language"
        },
        outputs: {
          modalAgreementDetails: "modalAgreementDetails"
        },
        decls: 48,
        vars: 93,
        consts: [[3, "headerClass", "bodyClass"], ["header", ""], [1, "d-flex", "flex-column", "flex-lg-row"], [1, "d-flex", "flex-column", "col-lg-6", "mb-32", "mb-lg-0", "pl-0", "pr-0", "pr-lg-48"], [1, "accessory-sub-heading"], [1, "text-body-lg"], [1, "text-body-lg", "mb-0"], [1, "d-flex", "flex-column", "col-lg-6", "pl-0", "pl-lg-48", "pr-0"], [1, "d-flex", "flex-column", "flex-sm-row", "mb-16", "mb-sm-8"], [1, "accessory-label", "text-title-5"], [1, "accessory-value", "text-sm-right", 3, "ariaLiveDesc", "language", "price", "frequency"], [1, "d-flex", "flex-column", "flex-sm-row", "mb-24"], [1, "accessory-value", "text-body-lg", "mb-0", "text-sm-right"], [1, "see-more-details-btn", "text-sm-right"], ["ds-button", "", 1, "w-100", "w-sm-auto", "text-capitalize", 3, "click", "variant"], ["body", ""], [1, "d-flex", "flex-wrap", "flex-column", "flex-sm-row"], [1, "accessory-item", "d-flex", "p-16", "px-sm-0", "justify-content-between", "justify-content-sm-start"], [1, "accessory-img", "mr-0", "mr-sm-16", 3, "alt", "src"], [1, "accessory-content", "d-flex", "flex-column"], [1, "text-body-sm"], [1, "text-body", "text-bold"], [1, "text-body"], [1, "text-body-sm", "mb-0"]],
        template: function AccessoriesDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ss-tile-with-header", 0);
            i0.ɵɵelementContainerStart(1, 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "span", 4);
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "customDate");
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "span", 5);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "customDate");
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "span", 5);
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "span", 6);
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "div", 7)(20, "div", 8)(21, "span", 9);
            i0.ɵɵpipe(22, "translate");
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(26, "ds-price", 10);
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵpipe(28, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "div", 11)(30, "span", 9);
            i0.ɵɵpipe(31, "translate");
            i0.ɵɵpipe(32, "translate");
            i0.ɵɵtext(33);
            i0.ɵɵpipe(34, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(35, "span", 12);
            i0.ɵɵtext(36);
            i0.ɵɵpipe(37, "currency");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(38, "div", 13)(39, "button", 14);
            i0.ɵɵpipe(40, "translate");
            i0.ɵɵpipe(41, "translate");
            i0.ɵɵlistener("click", function AccessoriesDetailsComponent_Template_button_click_39_listener() {
              return ctx.emitAgreementDetails();
            });
            i0.ɵɵtext(42);
            i0.ɵɵpipe(43, "translate");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementContainerStart(44, 15);
            i0.ɵɵelementStart(45, "div", 16);
            i0.ɵɵrepeaterCreate(46, AccessoriesDetailsComponent_For_47_Template, 17, 26, "div", 17, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("headerClass", "p-24 p-sm-32 py-sm-24")("bodyClass", "px-16 py-24");
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 25, "financed-accessories.financing-ending", i0.ɵɵpureFunction1(74, _c9, i0.ɵɵpipeBind2(6, 22, ctx.agreementDetail.contractEnd, ctx.language))), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(11, 31, "financed-accessories.financing-started", i0.ɵɵpureFunction1(76, _c10, i0.ɵɵpipeBind2(10, 28, ctx.agreementDetail.contractStart, ctx.language))), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(14, 34, "financed-accessories.agreement-id", i0.ɵɵpureFunction1(78, _c11, ctx.agreementDetail.agreementNumber)), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(17, 37, "financed-accessories.financing-term", i0.ɵɵpureFunction1(80, _c12, ctx.agreementDetail.agreementTerm)), " ", i0.ɵɵpipeBind1(18, 40, "financed-accessories.months"), " ");
            i0.ɵɵadvance(5);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(22, 42, "financed-accessories.monthly-financing-payment-alt", i0.ɵɵpureFunction1(82, _c11, ctx.agreementDetail.agreementNumber)))("title", i0.ɵɵpipeBind2(23, 45, "financed-accessories.monthly-financing-payment-alt", i0.ɵɵpureFunction1(84, _c11, ctx.agreementDetail.agreementNumber)));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 48, "financed-accessories.monthly-financing-payment"), "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ariaLiveDesc", i0.ɵɵpipeBind1(27, 50, "financed-accessories.monthly-financing-payment"))("language", ctx.language)("price", ctx.agreementDetail.monthlyAmount)("frequency", i0.ɵɵpipeBind1(28, 52, "financed-accessories.mo"));
            i0.ɵɵadvance(4);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(31, 54, "financed-accessories.balance-remaining-alt", i0.ɵɵpureFunction1(86, _c11, ctx.agreementDetail.agreementNumber)))("title", i0.ɵɵpipeBind2(32, 57, "financed-accessories.balance-remaining-alt", i0.ɵɵpureFunction1(88, _c11, ctx.agreementDetail.agreementNumber)));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(34, 60, "financed-accessories.balance-remaining"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBindV(37, 62, i0.ɵɵpureFunction2(90, _c6, ctx.agreementDetail.remainingBalance, ctx.language)), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("variant", "secondary");
            i0.ɵɵattribute("title", i0.ɵɵpipeBind1(40, 68, "financed-accessories.see-more-details-btn-alt"))("aria-label", i0.ɵɵpipeBind1(41, 70, "financed-accessories.see-more-details-btn-alt"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(43, 72, "financed-accessories.see-more-details-btn"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx.agreementDetail.accessories);
          }
        },
        dependencies: [i2.PriceComponent, i2$2.ButtonComponent, i3.TileWithHeaderComponent, i1.CurrencyPipe, i1$1.TranslatePipe, i7.CustomDatePipe],
        styles: ["@-ms-viewport{width:device-width}.accessory-label{width:70%;padding-right:16px;margin-bottom:0}.accessory-sub-heading{margin-bottom:1.6rem;font-size:2.4rem;font-weight:600;line-height:1.3}.accessory-value{width:30%}.accessory-item{flex:0 1 33%}@media (max-width: 1199.98px){.accessory-item{flex:0 1 50%}}.accessory-img{order:1;width:96px;height:96px}.accessory-content{order:2}.accessory-content span:not(:last-child){margin-bottom:8px}@media (max-width: 599.98px){.accessory-label{width:100%;padding:0;margin-bottom:8px;text-align:left}.accessory-sub-heading{font-size:2rem}.accessory-value{width:100%}.accessory-img{order:2}.accessory-content{order:1}}.see-more-details-btn{margin-top:auto}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return AccessoriesDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesComponent = /*#__PURE__*/(() => {
  class AccessoriesComponent {
    constructor(config, modalService, quickLinkService) {
      this.config = config;
      this.modalService = modalService;
      this.quickLinkService = quickLinkService;
    }
    ngOnInit() {
      this.quickLinks = this.quickLinkService.getQuickLinks$();
    }
    ngOnDestroy() {
      if (this.modalRef) {
        this.modalService.close(this.modalRef);
        this.modalRef = null;
      }
    }
    openAgreementDetailsModal(modalData) {
      const agreementDetailsModal = new ModalInjectableData(modalData);
      this.modalRef = this.modalService.open(AccessoriesDetailsModalComponent, this.config.viewContainerRef, this.config.modalWindowConfig, agreementDetailsModal);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesComponent_Factory(t) {
        return new (t || AccessoriesComponent)(i0.ɵɵdirectiveInject(AccessoriesConfigService), i0.ɵɵdirectiveInject(i2$1.ModalService), i0.ɵɵdirectiveInject(i3$1.QuickLinkService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AccessoriesComponent,
        selectors: [["ss-accessories"]],
        inputs: {
          accessoriesDetail: "accessoriesDetail"
        },
        decls: 15,
        vars: 14,
        consts: [[1, "container", "p-0", "px-sm-24", "mt-40"], [1, "pl-24", "pl-sm-0", "mb-16", "mb-sm-24"], [1, "text-title-2", "text-uppercase", "mb-8"], [1, "ds-color-steel-head"], [1, "mb-40", "mb-sm-32"], [3, "accessoriesDetail", "headerClass", "language"], [1, "mb-24", "mb-sm-40"], [1, "py-24", "py-sm-32", "ds-bgcolor-white"], [1, "container", "pl-48"], [3, "quickLinks", "headerTranslationKey"], [3, "modalAgreementDetails", "agreementDetail", "language"]],
        template: function AccessoriesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "div", 1)(2, "h1", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "span", 3);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 4);
            i0.ɵɵelement(9, "ss-accessories-balance", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵrepeaterCreate(10, AccessoriesComponent_For_11_Template, 2, 2, "div", 6, _forTrack0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "section", 7)(13, "div", 8);
            i0.ɵɵelement(14, "ss-quick-links", 9);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 7, "financed-accessories.title"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(7, 9, "financed-accessories.account-number", i0.ɵɵpureFunction1(12, _c14, ctx.accessoriesDetail.accountNumber)));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("accessoriesDetail", ctx.accessoriesDetail)("headerClass", "p-24 p-sm-32 ds-bgcolor-white")("language", ctx.accessoriesDetail.language);
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.accessoriesDetail.agreementDetails);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("quickLinks", ctx.quickLinks)("headerTranslationKey", "financed-accessories.quick-links.header");
          }
        },
        dependencies: [i3$1.QuickLinkComponent, AccessoriesBalanceComponent, AccessoriesDetailsComponent, i1$1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AccessoriesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const quickLinks = [{
  label: 'financed-accessories.quick-links.faq',
  url: 'https://forums.fido.ca/t5/phones-and-devices/fido-payment-program-faqs/ta-p/157242',
  isExternalLink: true,
  openInNewTab: false
}];
let AccessoriesQuickLinkService = /*#__PURE__*/(() => {
  class AccessoriesQuickLinkService extends QuickLinkService {
    constructor(translateService) {
      super(translateService);
      this.translateService = translateService;
    }
    getQuickLinks$() {
      return quickLinks;
    }
    handleLinkClick(link) {
      super.handleLinkClick(link);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesQuickLinkService_Factory(t) {
        return new (t || AccessoriesQuickLinkService)(i0.ɵɵinject(i1$1.TranslateService));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccessoriesQuickLinkService,
        factory: AccessoriesQuickLinkService.ɵfac
      });
    }
  }
  return AccessoriesQuickLinkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesModule = /*#__PURE__*/(() => {
  class AccessoriesModule {
    /** @nocollapse */static {
      this.ɵfac = function AccessoriesModule_Factory(t) {
        return new (t || AccessoriesModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AccessoriesModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: QuickLinkService,
          useClass: AccessoriesQuickLinkService
        }],
        imports: [CommonModule, TranslateModule.forChild(), PriceComponent, TileComponent, CustomDateModule, ButtonComponent, ModalModule, AnalyticsModule, TileWithHeaderModule, QuickLinksModule]
      });
    }
  }
  return AccessoriesModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const clearAccessoriesDetails = createAction('[AccessoriesDetail] Clear Accessories detail');
const loadAccessoriesDetail = createAction('[AccessoriesDetail] Load Accessories detail', props());
const loadAccessoriesDetailFail = createAction('[AccessoriesDetail] Load Accessories detail failed', props());
const loadAccessoriesDetailSuccess = createAction('[AccessoriesDetail] Load Accessories detail success', props());
const accessoriesDetailStateName = 'accessoriesDetail';
const adapter$1 = createEntityAdapter({
  selectId: accessoriesDetailEntity => `${accessoriesDetailEntity.accountNumber}_${accessoriesDetailEntity.language}`
});
const initialState$1 = adapter$1.getInitialState({
  // additional entity state properties
});
const createAccessoriesDetailReducer = createReducer(initialState$1, on(loadAccessoriesDetail, (state, action) => adapter$1.upsertOne({
  accountNumber: action.payload.accountNumber,
  language: action.payload.language,
  error: null,
  hasError: false,
  loading: true
}, state)), on(loadAccessoriesDetailSuccess, (state, action) => adapter$1.upsertOne({
  ...action.payload,
  hasError: false,
  loaded: true,
  loading: false
}, state)), on(loadAccessoriesDetailFail, (state, action) => adapter$1.upsertOne({
  ...action.payload,
  hasError: true,
  loaded: false,
  loading: false
}, state)), on(clearAccessoriesDetails, state => adapter$1.removeAll(state)));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function accessoriesDetailReducer(state, action) {
  return createAccessoriesDetailReducer(state, action);
}
const {
  selectEntities: selectEntities$1
} = adapter$1.getSelectors();
const accessoriesDetailEntityState = createFeatureSelector(accessoriesDetailStateName);
const selectAccessoriesDetailEntities = createSelector(accessoriesDetailEntityState, selectEntities$1);
const selectAccessoriesDetailEntity = createSelector(selectAccessoriesDetailEntities, accessoriesDetailEntities => (accountNumber, language) => accessoriesDetailEntities[`${accountNumber}_${language}`]);
const getAccessoriesDetail = (accountNumber, language) => createSelector(selectAccessoriesDetailEntity, f => f(accountNumber, language));

/* eslint-disable */
let AccessoriesDetailFacadeService = /*#__PURE__*/(() => {
  class AccessoriesDetailFacadeService {
    constructor(store) {
      this.store = store;
    }
    getAccessoriesDetail$(accountNumber, language) {
      return this.getAccessoriesDetailEntity$(accountNumber, language).pipe(filter(accessoriesDetailEntity => !!accessoriesDetailEntity && (accessoriesDetailEntity.loaded || accessoriesDetailEntity.hasError)));
    }
    loadAccessoriesDetail$({
      accountAlias,
      accountNumber,
      language,
      subscriptionAlias
    }) {
      return of(accountNumber).pipe(withLatestFrom(this.getAccessoriesDetailEntity$(accountNumber, language)), tap(([_, accessoriesDetailEntity]) => {
        if (!!accessoriesDetailEntity && (accessoriesDetailEntity.loaded || accessoriesDetailEntity.loading)) {
          return;
        }
        return this.store.dispatch(loadAccessoriesDetail({
          payload: {
            accountAlias,
            accountNumber,
            language,
            subscriptionAlias
          }
        }));
      }));
    }
    getAccessoriesDetailEntity$(accountNumber, language) {
      return this.store.select(getAccessoriesDetail(accountNumber, language));
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesDetailFacadeService_Factory(t) {
        return new (t || AccessoriesDetailFacadeService)(i0.ɵɵinject(i1$3.Store));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccessoriesDetailFacadeService,
        factory: AccessoriesDetailFacadeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessoriesDetailFacadeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesDetailEffects = /*#__PURE__*/(() => {
  class AccessoriesDetailEffects {
    constructor(actions$, config, httpClient) {
      this.actions$ = actions$;
      this.config = config;
      this.httpClient = httpClient;
      this.loadAccessoriesDetail$ = createEffect(() => this.actions$.pipe(ofType(loadAccessoriesDetail), switchMap(({
        payload
      }) => {
        const {
          accountNumber,
          accountAlias,
          language,
          subscriptionAlias
        } = payload;
        return this.getAccessoriesDetail$(accountAlias, language, subscriptionAlias).pipe(map(accessoryDetail => loadAccessoriesDetailSuccess({
          payload: accessoryDetail
        })), catchError(error => {
          return of(loadAccessoriesDetailFail({
            payload: {
              accountNumber,
              error: this.config.getErrorTrackingObject(error),
              language
            }
          }));
        }));
      })));
    }
    getAccessoriesDetail$(accountAlias, language, subscriptionAlias) {
      const url = `${this.config.financedAccessoriesBaseUrl}${accountAlias}/subscriptions/${subscriptionAlias}` + '/financed-accessories';
      return this.httpClient.get(url, {
        headers: this.config.getHeaders(language)
      }).pipe(map(response => this.transformAccessoriesDetailContent(response.content, language)));
    }
    transformAccessoriesDetailContent(content, language) {
      const {
        accountNumber,
        agreementDetails,
        subscriptionNumber,
        totalMonthlyAmount,
        totalRemainingBalance
      } = content;
      const transformedAgreementDetails = !!agreementDetails ? agreementDetails.map(agreementDetail => {
        const {
          accessories,
          agreementNumber,
          agreementTerm,
          contractEnd,
          contractStart,
          monthlyAmount,
          remainingBalance,
          preTaxRemainingBalance,
          taxOnRemainingBalance,
          preTaxMonthlyInstallment,
          taxOnMonthlyInstallment
        } = agreementDetail;
        accessories.forEach(accessory => {
          if (!accessory.iconUrl) {
            accessory.iconUrl = './assets/i/financed-accessories/default-accessory.svg';
          }
        });
        return {
          accessories,
          agreementNumber,
          agreementTerm,
          contractStart: parseISOString(contractStart),
          contractEnd: parseISOString(contractEnd),
          monthlyAmount,
          remainingBalance,
          preTaxRemainingBalance,
          taxOnRemainingBalance,
          preTaxMonthlyInstallment,
          taxOnMonthlyInstallment
        };
      }) : [];
      return {
        accountNumber,
        agreementDetails: transformedAgreementDetails,
        language,
        subscriptionNumber,
        totalMonthlyAmount,
        totalRemainingBalance,
        preTaxRemainingBalance: content.preTaxRemainingBalance,
        taxOnRemainingBalance: content.taxOnRemainingBalance,
        preTaxMonthlyInstallment: content.preTaxMonthlyInstallment,
        taxOnMonthlyInstallment: content.taxOnMonthlyInstallment
      };
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesDetailEffects_Factory(t) {
        return new (t || AccessoriesDetailEffects)(i0.ɵɵinject(i1$4.Actions), i0.ɵɵinject(AccessoriesConfigService), i0.ɵɵinject(i3$2.HttpClient));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccessoriesDetailEffects,
        factory: AccessoriesDetailEffects.ɵfac
      });
    }
  }
  return AccessoriesDetailEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesDetailStoreModule = /*#__PURE__*/(() => {
  class AccessoriesDetailStoreModule {
    /** @nocollapse */static {
      this.ɵfac = function AccessoriesDetailStoreModule_Factory(t) {
        return new (t || AccessoriesDetailStoreModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AccessoriesDetailStoreModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [StoreModule.forFeature(accessoriesDetailStateName, accessoriesDetailReducer), EffectsModule.forFeature([AccessoriesDetailEffects])]
      });
    }
  }
  return AccessoriesDetailStoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const clearAccessoriesSummaries = createAction('[AccessoriesSummary] Clear Accessories summary');
const loadAccessoriesSummary = createAction('[AccessoriesSummary] Load Accessories summary', props());
const loadAccessoriesSummaryFail = createAction('[AccessoriesSummary] Load Accessories summary failed', props());
const loadAccessoriesSummarySuccess = createAction('[AccessoriesSummary] Load Accessories summary success', props());
const accessoriesSummaryStateName = 'accessoriesSummary';
const adapter = createEntityAdapter({
  selectId: accessoriesSummaryEntity => accessoriesSummaryEntity.accountNumber
});
const initialState = adapter.getInitialState({
  // additional entity state properties
});
const createAccessoriesSummaryReducer = createReducer(initialState, on(loadAccessoriesSummary, (state, action) => adapter.upsertOne({
  ...action.payload,
  error: null,
  hasError: false,
  loaded: false,
  loading: true
}, state)), on(loadAccessoriesSummarySuccess, (state, action) => adapter.upsertOne({
  ...action.payload,
  hasError: false,
  loaded: true,
  loading: false
}, state)), on(loadAccessoriesSummaryFail, (state, action) => adapter.upsertOne({
  ...action.payload,
  hasError: true,
  loaded: false,
  loading: false
}, state)), on(clearAccessoriesSummaries, state => adapter.removeAll(state)));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function accessoriesSummaryReducer(state, action) {
  return createAccessoriesSummaryReducer(state, action);
}
const {
  selectEntities
} = adapter.getSelectors();
const accessoriesSummaryEntityState = createFeatureSelector(accessoriesSummaryStateName);
const selectAccessoriesSummaryEntities = createSelector(accessoriesSummaryEntityState, selectEntities);
const selectAccessoriesSummaryEntity = createSelector(selectAccessoriesSummaryEntities, accessoriesSummaryEntities => accountNumber => accessoriesSummaryEntities[accountNumber]);
const getAccessoriesSummary = accountNumber => createSelector(selectAccessoriesSummaryEntity, f => f(accountNumber));

/* eslint-disable */
let AccessoriesSummaryFacadeService = /*#__PURE__*/(() => {
  class AccessoriesSummaryFacadeService {
    constructor(store) {
      this.store = store;
    }
    getAccessoriesSummary$(accountNumber) {
      return this.getAccessoriesSummaryEntity$(accountNumber).pipe(filter(accessoriesSummaryEntity => !!accessoriesSummaryEntity && (accessoriesSummaryEntity.loaded || accessoriesSummaryEntity.hasError)));
    }
    loadAccessoriesSummary(accountNumber, accountAlias) {
      of(accountNumber).pipe(withLatestFrom(this.getAccessoriesSummaryEntity$(accountNumber)), tap(([_, accessoriesSummaryEntity]) => {
        if (!!accessoriesSummaryEntity && (accessoriesSummaryEntity.loaded || accessoriesSummaryEntity.loading)) {
          return;
        }
        this.store.dispatch(loadAccessoriesSummary({
          payload: {
            accountNumber,
            accountAlias
          }
        }));
      })).subscribe();
    }
    getAccessoriesSummaryEntity$(accountNumber) {
      return this.store.select(getAccessoriesSummary(accountNumber));
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesSummaryFacadeService_Factory(t) {
        return new (t || AccessoriesSummaryFacadeService)(i0.ɵɵinject(i1$3.Store));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccessoriesSummaryFacadeService,
        factory: AccessoriesSummaryFacadeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessoriesSummaryFacadeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesSummaryEffects = /*#__PURE__*/(() => {
  class AccessoriesSummaryEffects {
    constructor(actions$, config, httpClient) {
      this.actions$ = actions$;
      this.config = config;
      this.httpClient = httpClient;
      this.loadAccessoriesSummary$ = createEffect(() => this.actions$.pipe(ofType(loadAccessoriesSummary), mergeMap(({
        payload
      }) => {
        const {
          accountNumber,
          accountAlias
        } = payload;
        return this.getAccessoriesSummary$(accountAlias).pipe(map(summary => loadAccessoriesSummarySuccess({
          payload: summary
        })), catchError(error => of(loadAccessoriesSummaryFail({
          payload: {
            accountAlias,
            accountNumber,
            error: this.config.getErrorTrackingObject(error)
          }
        }))));
      })));
    }
    getAccessoriesSummary$(accountAlias) {
      const url = `${this.config.financedAccessoriesBaseUrl}${accountAlias}/financed-accessories`;
      return this.httpClient.get(url, {
        headers: this.config.getHeaders()
      }).pipe(map(response => {
        const {
          accountNumber,
          subscriptionAlias,
          subscriptionNumber,
          totalRemainingBalance
        } = response.content;
        return {
          accountNumber,
          accountAlias,
          hasUnpaidAccessories: !!totalRemainingBalance && totalRemainingBalance > 0,
          subscriptionAlias,
          subscriptionNumber,
          totalRemainingBalance
        };
      }));
    }
    /** @nocollapse */
    static {
      this.ɵfac = function AccessoriesSummaryEffects_Factory(t) {
        return new (t || AccessoriesSummaryEffects)(i0.ɵɵinject(i1$4.Actions), i0.ɵɵinject(AccessoriesConfigService), i0.ɵɵinject(i3$2.HttpClient));
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AccessoriesSummaryEffects,
        factory: AccessoriesSummaryEffects.ɵfac
      });
    }
  }
  return AccessoriesSummaryEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AccessoriesSummaryStoreModule = /*#__PURE__*/(() => {
  class AccessoriesSummaryStoreModule {
    /** @nocollapse */static {
      this.ɵfac = function AccessoriesSummaryStoreModule_Factory(t) {
        return new (t || AccessoriesSummaryStoreModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AccessoriesSummaryStoreModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [StoreModule.forFeature(accessoriesSummaryStateName, accessoriesSummaryReducer), EffectsModule.forFeature([AccessoriesSummaryEffects])]
      });
    }
  }
  return AccessoriesSummaryStoreModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AccessoriesComponent, AccessoriesConfigService, AccessoriesDetailFacadeService, AccessoriesDetailStoreModule, AccessoriesDetailsModalComponent, AccessoriesModule, AccessoriesSummaryFacadeService, AccessoriesSummaryStoreModule };
